import { cn } from '@lensora/ui'

import { formatPlatformName, isGrowthGatedPlatform, PICKER_PLATFORMS, PlatformIcon } from './PlatformIcon'

interface PlatformStat {
  mentioned: number
  total: number
}

interface PlatformCarouselProps {
  platformStats: Record<string, PlatformStat>
  isGrowthPlus: boolean
}

export function PlatformCarousel({ platformStats, isGrowthPlus }: PlatformCarouselProps) {
  return (
    <div>
      <p className="mb-2.5 text-[11px] font-semibold uppercase tracking-wide text-text-muted">
        Visibility by platform
      </p>
      <div className="flex gap-2.5 overflow-x-auto pb-1.5">
        {PICKER_PLATFORMS.map((key) => {
          const stat = platformStats[key]
          const locked = isGrowthGatedPlatform(key) && !isGrowthPlus
          const pct = stat && stat.total > 0 ? Math.round((stat.mentioned / stat.total) * 100) : null

          return (
            <div
              key={key}
              className={cn(
                'min-w-[155px] shrink-0 rounded-2xl border bg-surface px-4 py-3.5',
                locked ? 'border-border opacity-60' : 'border-border-strong'
              )}
            >
              <div className="mb-2.5 flex items-center gap-2">
                <PlatformIcon platform={key} size={18} />
                <span className="text-sm font-semibold text-text">{formatPlatformName(key)}</span>
                {locked && (
                  <span className="rounded-full border border-brand-accent/30 bg-brand-accent/10 px-1.5 py-0.5 text-[10px] text-brand-accent">
                    Growth+
                  </span>
                )}
              </div>

              <p className="mb-0.5 text-[22px] font-bold leading-none text-text">
                {pct !== null ? `${pct}%` : '—'}
              </p>
              <p className="mb-2.5 text-[11px] text-text-muted">
                {stat && stat.total > 0
                  ? `${stat.mentioned} of ${stat.total} responses`
                  : locked
                    ? 'Upgrade to unlock'
                    : 'No scans yet'}
              </p>

              <div className="h-1 overflow-hidden rounded-full bg-border">
                <div
                  className="h-1 rounded-full bg-brand-accent transition-[width] duration-500 ease-out"
                  style={{ width: `${pct ?? 0}%` }}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
